import React from "react";
import { getInceptionTheme } from "../../themes/ThemeProvider";
import { IncFaIcon, IncErrorIcon } from "../../icons";
import { IncToolTip } from "../antd-components";

interface Props {
  value: number;
  onIncrement: () => void;
  onDecrement: () => void;
  containerClass?: string;
  errorText?: string;
  hasError?: boolean;
}

const IntegerTextfield: React.FC<Props> = (props: Props) => {
  const { value, onIncrement, onDecrement, containerClass, errorText = "", hasError = false } = props;
  const classes = `inc-integer-text-field container ${containerClass || ""} ${hasError ? "error-border" : ""}`;

  const errComponent =
    errorText && hasError ? (
      <IncToolTip
        placement="top-start"
        showArrow
        titleText={errorText}
        variant="error"
      >
        <IncErrorIcon
          style={{
            color: getInceptionTheme().inceptionColors.palette.R400
          }}
        />
      </IncToolTip>
    ) : (
      <></>
    );

  return (
    <>
      <div className={classes}>
        <span className="marginRt8">{value}</span>
        <div className="inc-flex-column increment-decrement-handles">
          <span
            className="caret-icon"
            onClick={onIncrement}
          >
            <IncFaIcon iconName="caret-up" />
          </span>
          <span
            className="caret-icon"
            onClick={onDecrement}
          >
            <IncFaIcon iconName="caret-down" />
          </span>
        </div>
      </div>
      <span className="inc-flex-self-center">{errComponent}</span>
    </>
  );
};

export default IntegerTextfield;
